"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getNextStepValues = function getNextStepValuesRangeHelper(eventMousePosition, direction, steps) {
  var threshold = steps[0].threshold;
  var adjustedMousePosition = direction === 'right' ? eventMousePosition + threshold : eventMousePosition;
  var nextPosition = null;

  for (var i = 0; i < steps.length; i += 1) {
    if (adjustedMousePosition > steps[i].pixels) {
      nextPosition = steps[i];
    }
  }

  return nextPosition;
};

var _default = getNextStepValues;
exports["default"] = _default;